var _circle, _mask, _g, _mask2, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStreamOutput(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 11,
    r: 1.5,
    stroke: "#323130"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "StreamOutput_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 6,
    width: 6,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 6.556V16l-6-2.778V8.778l6-2.222z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#StreamOutput_svg__a)",
    stroke: "#323130"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 11,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11c0 2.595-1.665 4.5-3.5 4.5S8.5 13.595 8.5 11c0-2.595 1.665-4.5 3.5-4.5s3.5 1.905 3.5 4.5z"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "StreamOutput_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0v6H5v4H0V0h15z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#StreamOutput_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.98 4a3.014 3.014 0 012.78 1.82c.16.36.24.76.24 1.18 0 .42-.08.81-.23 1.17-.16.36-.37.68-.65.95-.27.27-.59.48-.95.64-.37.16-.76.24-1.17.24H4c-.55 0-1.07-.1-1.56-.31s-.91-.49-1.28-.85C.8 8.47.52 8.05.31 7.56.1 7.07 0 6.55 0 6s.1-1.07.31-1.55c.21-.49.49-.92.85-1.28s.79-.65 1.27-.86C2.93 2.1 3.45 2 4 2c.24 0 .48.02.73.07.2-.32.44-.61.72-.87.28-.26.58-.48.9-.66.32-.18.67-.31 1.03-.41C7.74.05 8.11 0 8.5 0c.58 0 1.12.1 1.63.3.52.2.97.48 1.37.84.4.35.72.78.98 1.27s.42 1.02.5 1.59zM13 9c.28 0 .53-.05.77-.16.24-.1.46-.25.64-.43s.33-.39.43-.63c.11-.24.16-.5.16-.78s-.05-.53-.16-.77a2.003 2.003 0 00-1.07-1.07C13.53 5.05 13.28 5 13 5h-1v-.5c0-.48-.09-.94-.27-1.36-.18-.43-.43-.8-.75-1.12-.32-.32-.69-.57-1.12-.75A3.44 3.44 0 008.5 1c-.36 0-.72.05-1.05.16-.34.11-.66.27-.94.46-.28.2-.53.44-.75.72-.22.28-.4.59-.53.93a3.014 3.014 0 00-2.4-.04c-.36.16-.68.38-.96.65A3 3 0 001 6c0 .42.08.81.23 1.17.16.36.37.68.64.95.28.28.6.49.96.65.36.15.75.23 1.17.23h9z",
    fill: "#323130"
  }))));
}

export default SvgStreamOutput;